import { useContext, useEffect, useState } from "react"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { WebSocketContext } from "../../../../../../Providers/WebSocket/WebSocketContext"
import { Button, Divider, Typography } from "@mui/material"
import OneInput from "../../../../../../Components/OneInput/OneInput"
import OneModal from "../../../../../../Components/OneModal/OneModal"
import { OneSwitch } from "../../../../../../Components/OneSwitch/OneSwitch"
import OneSelect from "../../../../../../Components/OneSelect/OneSelect"
import { PhotoCameraFront } from "@mui/icons-material"
import { showNotify } from "../../../../../../Utils/Utils"
import SnapshotModal from "../../../../../../Components/SnapshotModal/SnapshotModal"

const EdicaoEntrada = ({ idToEdit, idCentral, openEntrada, setOpenEntrada }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    // const [formData, setFormData] = useState(null)
    const [formData, setFormData] = useState({
        entrada: { }
    })

    const [initialData, setInitialData] = useState()

    const [cameraScreenshot, setCameraScreenshot] = useState(null)
    const [openSnapshot, setOpenSnapshot] = useState(false)
    const [idScreenshot, setIdScreenshot] = useState(null)

    const handleSnapshot = (id) => {
        setIdScreenshot(id)
        setOpenSnapshot(true)
    }

    const getEntrada = (msg) => {
        if (msg.data.status) {
            const initialCameras = [
                { id: 0, id_entrada: 0, id_camera: '0', ordem: 1 },
                { id: 0, id_entrada: 0, id_camera: '0', ordem: 2 },
                { id: 0, id_entrada: 0, id_camera: '0', ordem: 3 },
                { id: 0, id_entrada: 0, id_camera: '0', ordem: 4 }
            ]
            msg.data.entrada.cameras?.map((camera) => {
                initialCameras[camera.ordem - 1] = camera
            })
            let camerasId = []
            for (const camera of initialCameras) {
                camerasId.push(camera.id_camera)
            }
            setCameraScreenshot(camerasId)
            const toInitial = { ...msg.data.entrada, optionsCameras: [{ id: "0", nome_exibicao: "Nenhuma" }, ...msg.data.cameras], cameras: initialCameras }

            setInitialData(toInitial)
        }
    }

    useEffect(() => {
        addRoute("buscarEntrada", getEntrada)
        let stringId = idToEdit != null ? `${idToEdit}` : null
        sendWs("buscarEntrada", { id: stringId, condId: idCentral })
    }, [])

    const handleChange = (event) => {
        if (event.target.value !== undefined) {
            const { name, value, type, checked } = event.target
            setFormData((prevFormData) => ({
                ...prevFormData,
                entrada: {
                    ...prevFormData.entrada,
                    [name]: type === 'checkbox' ? checked : value
                },
                id_central: idCentral
            }))
        }
    }

    // const handleChange = (event) => {
    //     if (event.target.value != undefined) {
    //         if (event.target.type == 'checkbox') {
    //             setFormData({ ...formData, entrada: { [event.target.name]: event.target.checked } })
    //         } else {
    //             setFormData({ ...formData, entrada: { [event.target.name]: event.target.value } })
    //         }
    //     }
    // }

    const handleCameras = (event) => {
        const initialCamera = initialData.cameras?.filter((camera) => camera.ordem == event.target.name)[0] || null
        const currentFormData = { ...formData }
        if (!currentFormData.cameras) {
            currentFormData.cameras = []
        }
        if (currentFormData.cameras.length == 0) {
            currentFormData.cameras.push(
                {
                    id: initialCamera ? initialCamera.id : 0,
                    id_camera: event.target.value,
                    ordem: event.target.name
                }
            )
        } else {
            const indexCamera = currentFormData.cameras.findIndex((camera) => {
                return camera.ordem == event.target.name
            })
            if (indexCamera == -1) {
                currentFormData.cameras.push(
                    {
                        id: initialCamera ? initialCamera.id : 0,
                        id_camera: event.target.value,
                        ordem: event.target.name
                    }
                )
            } else {
                currentFormData.cameras[indexCamera] =
                    {
                        id: initialCamera ? initialCamera.id : 0,
                        id_camera: event.target.value,
                        ordem: event.target.name
                    }
            }
        }
        setFormData(currentFormData)
        let newArrayScreenshot = [...cameraScreenshot]
        newArrayScreenshot[event.target.name - 1] = event.target.value
        setCameraScreenshot(newArrayScreenshot)
    }

    const responseSumbit = (msg) => {
        if (msg.data.status == "error") {
            showNotify("error", msg.data.message)
        } else if (msg.data.status) {
            showNotify("success", "Dados salvos com sucesso!")
            setOpenEntrada(false)
            sendWs("buscarTodasEntradas", { condId: idCentral })
        } else if (!msg.data.status) {
            showNotify("error", msg.data.message)
        }
    }

    addRoute("editarEntrada", responseSumbit)

    const handleSubmit = async (event) => {
        event.preventDefault()

        if (!formData) {
            showNotify("warning", "Nenhuma alteração feita!")
            return
        }

        // await formData.cameras?.map((camera) => {
        //     if (camera.id_camera == 0) {
        //         return
        //     }
        //     formData.cameras.map((cam2) => {
        //         if (camera.id_camera == cam2.id_camera && camera.ordem != cam2.ordem) {
        //             repeatCamera = true
        //         }
        //     })
        //     initialData.cameras.map((cam2) => {
        //         if (camera.id_camera == cam2.id_camera && camera.ordem != cam2.ordem) {
        //             repeatCamera = true
        //         }
        //     })
        // })
        let repeatCamera = false
        let camerasAtuais = {}
        initialData.cameras.map((cameraInitial, index) => {
            let id = cameraInitial.id_camera.toString()
            let cameraForm = formData.cameras?.filter((camera) => camera.ordem == cameraInitial.ordem)[0]
            if (cameraForm) {
                id = cameraForm.id_camera.toString()
            }
            if (id > 0) {
                if (camerasAtuais[id] == undefined) {
                    camerasAtuais[id] = 1
                } else {
                    camerasAtuais[id] += 1
                }
            }
        })
        Object.values(camerasAtuais).map((value) => {
            if (value > 1) {
                repeatCamera = true
            }
        })

        if (repeatCamera == true) {
            showNotify('warning', 'Não é possível salvar a mesma câmera 2 vezes para a mesma entrada.')
            return
        }

        let data = formData

        if (data.entrada) {
            const newData = { id: initialData?.id }
            for (const prop in initialData) {
                if (Object.hasOwnProperty.call(initialData, prop)) {
                    if (initialData[prop] != data.entrada[prop] && data.entrada[prop] != undefined) {
                        newData[prop] = data.entrada[prop]
                    }
                }
            }

            data.entrada = newData
        } else {
            data.entrada = { id: initialData?.id }
        }

        sendWs("editarEntrada", data)
    }

    return (
        <OneModal
            open={openEntrada}
            setOpen={setOpenEntrada}
            titleText="Editar Entrada"
            FooterButtons={FooterButtons}
            fullWidth={true}
            onClose={false}
        >
            <form
                id="entrada-form"
                onSubmit={handleSubmit}
                style={{ width: '100%' }}
            >
                {openSnapshot &&
                    <SnapshotModal
                        openModal={openSnapshot}
                        setOpenModal={setOpenSnapshot}
                        cameraId={idScreenshot}
                    />
                }
                {initialData &&
                <Grid xs={12} sx={{ alignItems: 'center' }}>
                    <Grid container xs py={0.5} sx={{ alignItems: 'center' }}>
                        <Grid md>
                            <Grid container xs={7} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md={1.3}>
                                    <Typography fontSize="13px" fontWeight='400' >Descrição: </Typography>
                                </Grid>
                                <Grid xs md>
                                    <OneInput
                                        defaultValue={initialData?.descricao}
                                        maxLength="50"
                                        required
                                        onChange={handleChange}
                                        name={"descricao"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container xs py={0.5} sx={{ alignItems: 'center' }}>
                        <Grid md>
                            <Grid container xs={7} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md={1.7}>
                                    <Typography fontSize="13px" fontWeight='400' >Apelido: </Typography>
                                </Grid>
                                <Grid xs={12} md={9.5}>
                                    <OneInput
                                        defaultValue={initialData?.nome_porta_app}
                                        maxLength="255"
                                        required
                                        onChange={handleChange}
                                        name={"nome_porta_app"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid md={3}>
                            <Grid xs={7} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md>
                                    <OneSwitch
                                        defaultValue={initialData?.visivel}
                                        onChange={handleChange}
                                        name={"visivel"}
                                    />
                                </Grid>
                                <Grid xs={12} md={10}>
                                    <Typography fontSize="13px" fontWeight='400' >Visível </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container xs py={0.5} sx={{ alignItems: 'center' }}>
                        <Grid md={3.5}>
                            <Grid xs={7} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md>
                                    <OneSwitch
                                        defaultValue={initialData?.autorizacao_acionamento}
                                        onChange={handleChange}
                                        name={"autorizacao_acionamento"}
                                    />
                                </Grid>
                                <Grid xs={12} md={10}>
                                    <Typography fontSize="13px" fontWeight='400' >Pedir autorização acionar </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid md={3}>
                            <Grid xs={7} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md>
                                    <OneSwitch
                                        defaultValue={initialData?.monitorar_alarme}
                                        onChange={handleChange}
                                        name={"monitorar_alarme"}
                                    />
                                </Grid>
                                <Grid xs={12} md={10}>
                                    <Typography fontSize="13px" fontWeight='400' >Arrombamento </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid md={3}>
                            <Grid xs={7} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md>
                                    <OneSwitch
                                        defaultValue={initialData?.monitorar_porta_aberta}
                                        onChange={handleChange}
                                        name={"monitorar_porta_aberta"}
                                    />
                                </Grid>
                                <Grid xs={12} md={10}>
                                    <Typography fontSize="13px" fontWeight='400' >Porta Aberta </Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid md={2}>
                            <Grid xs={7} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md={5}>
                                    <OneInput
                                        defaultValue={initialData?.monitorar_porta_tempo}
                                        type="number"
                                        maxLength="50"
                                        required
                                        onChange={handleChange}
                                        name={"monitorar_porta_tempo"}
                                    />
                                </Grid>
                                <Grid xs={12} md={6}>
                                    <Typography fontSize="13px" fontWeight='400' ml={1} >seg. </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <br/>
                    <Typography fontSize="14px" fontWeight='400'>Câmeras para monitoramento:</Typography>
                    <Divider sx={{ marginBottom: '10px' }}/>
                    <Grid container xs py={0.5} sx={{ alignItems: 'center' }} gap={3}>
                        <Grid md>
                            <Grid xs={12} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md={1.5} sx={{ alignItems: 'center' }}>
                                    <Grid container sx={{ alignItems: 'center' }}>
                                        <PhotoCameraFront
                                            sx={{ color: '#0000008A', cursor: 'pointer' }}
                                            onClick={() => {
                                                handleSnapshot(cameraScreenshot[0])
                                            }}
                                        />
                                        <Typography fontSize="13px" fontWeight='400' ml={1}>1</Typography>
                                    </Grid>
                                </Grid>
                                <Grid xs={12} md>
                                    <OneSelect
                                        defaultValue={initialData?.cameras[0].id_camera || "0"}
                                        options={initialData?.optionsCameras}
                                        onChange={handleCameras}
                                        name={"1"}
                                        label={"nome_exibicao"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid md>
                            <Grid xs={12} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md={1.5} sx={{ alignItems: 'center' }}>
                                    <Grid container sx={{ alignItems: 'center' }}>
                                        <PhotoCameraFront
                                            sx={{ color: '#0000008A', cursor: 'pointer' }}
                                            onClick={() => {
                                                handleSnapshot(cameraScreenshot[1])
                                            }}
                                        />
                                        <Typography fontSize="13px" fontWeight='400' ml={1}>2</Typography>
                                    </Grid>
                                </Grid>
                                <Grid xs={12} md>
                                    <OneSelect
                                        defaultValue={initialData?.cameras[1].id_camera || "0"}
                                        options={initialData?.optionsCameras}
                                        onChange={handleCameras}
                                        name={"2"}
                                        label={"nome_exibicao"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container xs py={0.5} sx={{ alignItems: 'center' }} gap={3}>
                        <Grid md>
                            <Grid xs={12} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md={1.5} sx={{ alignItems: 'center' }}>
                                    <Grid container sx={{ alignItems: 'center' }}>
                                        <PhotoCameraFront
                                            sx={{ color: '#0000008A', cursor: 'pointer' }}
                                            onClick={() => {
                                                handleSnapshot(cameraScreenshot[2])
                                            }}
                                        />
                                        <Typography fontSize="13px" fontWeight='400' ml={1}>3</Typography>
                                    </Grid>
                                </Grid>
                                <Grid xs={12} md>
                                    <OneSelect
                                        defaultValue={initialData?.cameras[2].id_camera || "0"}
                                        options={initialData?.optionsCameras}
                                        onChange={handleCameras}
                                        name={"3"}
                                        label={"nome_exibicao"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid md>
                            <Grid xs={12} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md={1.5} sx={{ alignItems: 'center' }}>
                                    <Grid container sx={{ alignItems: 'center' }}>
                                        <PhotoCameraFront
                                            sx={{ color: '#0000008A', cursor: 'pointer' }}
                                            onClick={() => {
                                                handleSnapshot(cameraScreenshot[3])
                                            }}
                                        />
                                        <Typography fontSize="13px" fontWeight='400' ml={1}>4</Typography>
                                    </Grid>
                                </Grid>
                                <Grid xs={12} md>
                                    <OneSelect
                                        defaultValue={initialData?.cameras[3].id_camera || "0"}
                                        options={initialData?.optionsCameras}
                                        onChange={handleCameras}
                                        name={"4"}
                                        label={"nome_exibicao"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                }
            </form>
        </OneModal>
    )
}

export default EdicaoEntrada

const FooterButtons = () => {
    return (
        <Grid container xs={12} sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontSize: '13px', margin: 0, padding: 0 }}>* Campos obrigatórios!</span>
            <Button color="one_primary" variant="contained" form="entrada-form" type="submit">Salvar</Button>
        </Grid>
    )
}
